import React  from 'react';

import TextContentContainer from './ContentContainer';
import TextHeaderContainer from './HeaderContainer';

class TextContainer{}

TextContainer.Header = TextHeaderContainer;
TextContainer.Content = TextContentContainer;

export default TextContainer;


// WEBPACK FOOTER //
// ./src/containers/schedule/TextMode/index.js